import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './registerServiceWorker'
import icons from 'bootstrap-icons/font/bootstrap-icons.scss'

createApp(App).use(icons).use(router).use(store).mount('#app')
